interface BrandFilter {
  label: string;
}
export const byCustomBrandOrder =
  (customSortList: (string | number)[] | undefined) =>
  (a: BrandFilter, b: BrandFilter) => {
    const customSortOrder =
      customSortList?.map((v) => v.toString().replace(/<score=\d+>$/, '')) ??
      [];
    const aRank = customSortOrder.findIndex(
      (v) => v.toLocaleLowerCase() === a.label.toLocaleLowerCase()
    );
    const bRank = customSortOrder.findIndex(
      (v) => v.toLocaleLowerCase() === b.label.toLocaleLowerCase()
    );

    if (aRank === bRank) {
      return a.label.localeCompare(b.label);
    }
    if (aRank !== -1 && bRank !== -1) {
      return aRank - bRank;
    }
    return bRank - aRank;
  };
